import { render, staticRenderFns } from "./NegativeCheckResults.vue?vue&type=template&id=2dc1f506&scoped=true&"
import script from "./NegativeCheckResults.vue?vue&type=script&lang=js&"
export * from "./NegativeCheckResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc1f506",
  null
  
)

export default component.exports